module.exports = {"apiKey":"AIzaSyCd3yyVhOwgWcksjr1cuH_yH9DWhKJ1XlI","authDomain":"resume-makgupta.firebaseapp.com","databaseURL":"https://resume-makgupta.firebaseio.com"}


//////////////////
// WEBPACK FOOTER
// ./src/services/firebase-config.json
// module id = 682
// module chunks = 0